import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/*
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 * NOTA PRZYCZYNOWOŚCI — `.nota-przyczynowosc` z makiety
 * ══════════════════════════════════════════════════════════════════════════════════════════════
 *
 * DLACZEGO NA GÓRZE, A NIE W STOPCE. Makieta stawia ją NAD wszystkim, co opisuje, i ma rację:
 * zastrzeżenie przeczytane po wnioskach nie zmienia już decyzji, którą czytelnik zdążył podjąć.
 * Produkt miał dotąd zastrzeżenie WYŁĄCZNIE per karta — poprawne, ale widoczne dopiero wtedy,
 * gdy ktoś dojedzie do końca konkretnego sygnału. Zdanie rządzące całym ekranem musi stać przed
 * ekranem.
 *
 * DLACZEGO OSOBNY KOMPONENT, A NIE `Alert`. `Alert` MUI niesie semantykę ostrzeżenia o stanie
 * systemu („coś poszło nie tak"). To nie jest ostrzeżenie — to jest granica tego, co produkt
 * WIE, i obowiązuje zawsze, także gdy wszystko działa. Inny nośnik, bo inne znaczenie.
 *
 * `role="note"` zamiast `alert`: czytnik ekranu nie ma tego przerywać ani ogłaszać jako pilne.
 */

export function NotaPrzyczynowosci({
  tytul,
  children,
  kartaId,
}: {
  /** Zdanie-teza. Krótkie, w trybie orzekającym, bez „prosimy pamiętać". */
  tytul: string;
  children: ReactNode;
  kartaId?: string;
}) {
  return (
    <Box
      role="note"
      data-cc-card-id={kartaId}
      sx={{
        mb: 'var(--o4)',
        p: 'var(--o4)',
        borderRadius: 'var(--r-karta)',
        // Złoto jest kolorem marki, nie ostrzeżenia (tokens.css) — stąd lewa krawędź w kolorze
        // uwagi, ale bez tła alarmowego. Nota ma być czytana, nie odhaczana.
        borderLeft: '4px solid var(--uwaga)',
        background: 'var(--powierzchnia-2)',
      }}
    >
      <Typography
        component="strong"
        sx={{
          display: 'block',
          fontFamily: 'var(--krój-marka)',
          fontWeight: 900,
          fontSize: 'var(--st-sredni)',
          mb: 'var(--o2)',
        }}
      >
        {tytul}
      </Typography>
      <Typography variant="body2" sx={{ color: 'var(--tekst-2)', maxWidth: '78ch' }}>
        {children}
      </Typography>
    </Box>
  );
}
